import { useCallback, useState } from "react";

export function useAsyncError() {
    const [error, setError] = useState<Error | null>(null);

    const throwError = useCallback(
        (error: Error) => {
            setError(error);
        },
        [setError],
    );

    if (error) {
        throw error;
    }

    return throwError;
}
